import { useTemplateContext } from '../../../context';
import { EmailPrimaryContent } from '../../../types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { CommaSeparatedList, CommaSeparatedListItem, LightText } from '../Sections.styled';

export const EmailSendingInformationSection = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;

  const { fromEmail, ccEmails, fromName, replyTo, subject, preheaderText } =
    (primaryContent as EmailPrimaryContent) || {};

  return (
    <>
      <CampaignFormField labelText="From email">
        <ReadOnlyField name="fromEmail">
          {fromEmail || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="From name">
        <ReadOnlyField name="fromName">{fromName || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Reply to email">
        <ReadOnlyField name="replyTo">{replyTo || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Cc">
        <ReadOnlyField name="ccEmails">
          <CommaSeparatedList>
            {ccEmails?.length ? (
              ccEmails.map((e: string) => (
                <CommaSeparatedListItem key={e}>{e}</CommaSeparatedListItem>
              ))
            ) : (
              <LightText>Not set</LightText>
            )}
          </CommaSeparatedList>
        </ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Subject">
        <ReadOnlyField name="subject">{subject || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>

      <CampaignFormField labelText="Preheader">
        <ReadOnlyField name="preheaderText">
          {preheaderText || <LightText>Not set</LightText>}
        </ReadOnlyField>
      </CampaignFormField>
    </>
  );
};
